import { classNames } from '@/lib/classNames';
import { Drawer } from '@mantine/core';
import React from 'react';


type SideDrawerProps = React.PropsWithChildren<{
  maxWidthStyle?: string;
  open: boolean;
  setOpen: React.Dispatch<boolean>;
  title?: string;
  onClose?: () => void;
  size?: number;
  zIndex?: number;
  innerClassName?: string,

}>;

export const SideDrawer = ({
  maxWidthStyle,
  open,
  setOpen,
  title,
  onClose,
  size,
  children,
  zIndex,
  innerClassName,
}: SideDrawerProps): JSX.Element => {
  const onDrawerClose = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <Drawer
      opened={open}
      onClose={onDrawerClose}
      size={size ? size : 600}
      title={title}
      withCloseButton={!!title}
      position="right"
      overlayProps={{
        color: 'var(--color-overlay)'
      }}
      classNames={{
        title:
          'text-xl font-bold leading-relaxed text-secondary [.tactic-v2_&]:text-secondary-foreground sm:text-2xl sm:leading-snug',
        header: 'px-4 py-3 pt-4'
      }}
      zIndex={zIndex}
    >
      <div className={classNames('fixed inset-y-0 top-10 right-0 flex w-full', innerClassName)}>
        <div
          className={classNames(
            'flex h-full flex-1 flex-col bg-white p-4',
            maxWidthStyle
          )}
        >
          {children}
        </div>
      </div>
    </Drawer>
  );
};
